"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = __importDefault(require("@kawaui/button"));
const react_1 = require("react");
const context_1 = require("../context");
const styles_1 = require("../styles");
const utils_1 = require("../utils");
const Recover = ({ onRecover, onRouting, size, isCartPage, i18n }) => {
    const { checkList, onUnselected } = (0, react_1.useContext)(context_1.ExpiredContext);
    const handleClick = () => {
        if (!(0, utils_1.itemsSelected)(checkList))
            return onUnselected();
        return onRecover(checkList).then(() => {
            if (!isCartPage)
                onRouting(utils_1.CART_PAGE);
        });
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.Anchor, { href: utils_1.CART_PAGE, children: (0, jsx_runtime_1.jsx)(button_1.default, { isFullWidth: true, isAsync: true, variant: "primary", onClick: handleClick, size: size, children: i18n('cart_widget.expired.cta.1') }) }));
};
exports.default = Recover;
